import { hasLineItemType } from "./has-line-item-type.js";
const createContainsHelper = (lineItems) => {
  return {
    get contactLenses() {
      return lineItems ? hasLineItemType(lineItems, "CONTACT_LENSES") : false;
    },
    get prescriptionGlasses() {
      return lineItems ? hasLineItemType(lineItems, "GLASSES_BUNDLE") : false;
    },
    get nonPrescriptionBundle() {
      return lineItems ? hasLineItemType(lineItems, "NON_PRESCRIPTION_BUNDLE") : false;
    },
    get regular() {
      return lineItems ? hasLineItemType(lineItems, "REGULAR") : false;
    }
  };
};
export {
  createContainsHelper
};
//# sourceMappingURL=create-contains-helper.js.map
